import React, { useContext } from 'react';
import { FulfillmentSettingsType } from './types';

export const fulfillmentSettingsContext: React.Context<FulfillmentSettingsType> = React.createContext(
  {} as FulfillmentSettingsType,
);

export const useFulfillmentSettings = () => useContext(fulfillmentSettingsContext);
